/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2020-12-12 14:15:25
 * @LastEditors: jyf
 * @LastEditTime: 2020-12-16 15:11:07
 */
export interface AreaList {
    text:string
}

export interface AreaState {
    /**
     * 列表数据
     */
    listData: AreaList[]

    /**
     * 列表总数
     */
    total: number
}

let state: AreaState = {
    listData: [],
    total: 0
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/area/state.ts